import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './HomePage';
import EmotionCorner from './EmotionCorner';
import EmotionCornerStage1 from './EmotionCornerStage1';
import EmotionCornerStage2 from './EmotionCornerStage2';
import IdentifierGame from './IdentifierGame';
import Login from './Login';
import AdminLogin from './AdminLogin';
import Register from './Register';
import HospitalsPage from './HospitalsPage';
import UsersPage from './UsersPage';
import GalleryPage from './GalleryPage';
import ReportPage from './ReportPage';
import SessionsPage from './SessionsPage';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import { FRUITS, VEGETABLES, ANIMALS, SPORTS } from './categoryData';
import { AuthProvider } from './AuthContext';

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/register" element={<Register />} />

      {/* Admin-only routes */}
      <Route path="/hospitals" element={<AdminRoute element={<HospitalsPage />} />} />
      <Route path="/users" element={<AdminRoute element={<UsersPage />} />} />
      <Route path="/gallery" element={<AdminRoute element={<GalleryPage />} />} />
      <Route path="/report/:sessionId" element={<ProtectedRoute element={<ReportPage />} />} />
      <Route path="/sessions" element={<ProtectedRoute element={<SessionsPage />} />} />

      {/* Protected routes */}
      <Route path="/" element={<ProtectedRoute element={<HomePage />} />} />
      <Route path="/emotion-corner" element={<ProtectedRoute element={<EmotionCorner />} />} />
      <Route path="/emotion-corner-stage-1" element={<ProtectedRoute element={<EmotionCornerStage1 />} />} />
      <Route path="/emotion-corner-stage-2" element={<ProtectedRoute element={<EmotionCornerStage2 />} />} />
      <Route path="/fruits" element={<ProtectedRoute element={<IdentifierGame category={FRUITS} />} />} />
      <Route path="/vegetables" element={<ProtectedRoute element={<IdentifierGame category={VEGETABLES} />} />} />
      <Route path="/animals" element={<ProtectedRoute element={<IdentifierGame category={ANIMALS} />} />} />
      <Route path="/sports" element={<ProtectedRoute element={<IdentifierGame category={SPORTS} />} />} />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
